import { render } from "./makeable.vue?vue&type=template&id=4ed7a178&scoped=true"
import script from "./makeable.vue?vue&type=script&lang=js"
export * from "./makeable.vue?vue&type=script&lang=js"

import "./makeable.vue?vue&type=style&index=0&id=4ed7a178&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed7a178"]])

export default __exports__